import {DataSource, setMetadata} from '../core/data-source/data-source';
import {RestResponseRecord} from '../core/data-source/http-crud.data-source';
import {fromJson} from '../core/data-source/json.mapper';
import {httpService, IHttpRequestOptions} from '../core/services/http.service';

export class FileAttachmentsDataSource<T> extends DataSource<T> {
    protected apiPath: string = '/gt/gt-api/file-attachment';

    async orderAttachments(orderId: number, options?: IHttpRequestOptions): Promise<T[]> {
        return httpService.get(this.apiPath + '/order/' + orderId, options).then((response: any) => {
            return setMetadata(
                response.data.values.map((v: any) => fromJson(this.recordClass, v)),
                fromJson(RestResponseRecord, response.data)
            );
        });
    }
}
